package es.subastia.domain.model

data class UserDomainModel(
    val uid: String,
    val email: String?,
    val displayName: String?,
    val photoUrl: String?
)
